import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { Approval } from 'src/app/Modules/settings/models/common/setting-area.model';
import { UserUtilityService } from 'src/app/services';
import { MaterialModule } from 'src/app/shared/material.module';

@Component({
    selector: 'app-completed-approvals',
    templateUrl: './completed-approvals.component.html',
    styleUrl: './completed-approvals.component.scss',
    standalone: false
})
export class CompletedApprovalsComponent {
    displayedColumns: string[] = ['initiator', 'trigger', 'completedDate', 'item', 'itemType', 'state', 'By'];
    dataSource = new MatTableDataSource([]);
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    tooltip_position = 'above';
    iscreateApprovals: boolean;
    iseditApprovals: boolean;
    isDeleteApprovalsvisible: boolean;
    @Input() completedApprovalList: Approval[] = [];
    // Lookup objects for template binding
    constructor(private user_utility: UserUtilityService) {}

    async ngOnInit(): Promise<void> {
        this.iseditApprovals = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-approvals', userActions.Edit);
        this.isDeleteApprovalsvisible = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-approvals', userActions.Delete);
        this.iscreateApprovals = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-approvals', userActions.View);
        if (this.completedApprovalList?.length > 0) {
            let sortedArray = [...this.completedApprovalList].sort((a, b) => b.startDate - a.startDate);
            this.dataSource = new MatTableDataSource(sortedArray);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        } else {
            this.dataSource = new MatTableDataSource(this.completedApprovalList);
            this.dataSource.sort = this.sort;
        }
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes['completedApprovalList'] && this.completedApprovalList) {
            const sortedArray = [...this.completedApprovalList].sort((a, b) => b.startDate - a.startDate);
            this.dataSource.data = sortedArray;
        }
    }
}
